module.exports = __webpack_public_path__ + "img/start-title.7dc60d8c.png";